export default "__VITE_ASSET__qHTtrU7V__"